
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigateToPage = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="text-2xl font-light text-primary tracking-wide" style={{ fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif', letterSpacing: '0.5px' }}>
                Lavin Enterprises & Co.
              </div>
            </div>
          </div>

          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => navigateToPage('/')}
              className="text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              style={{ color: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.color = '#6B756B'}
              onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            >
              Home
            </button>
            <button 
              onClick={() => navigateToPage('/about')}
              className="text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              style={{ color: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.color = '#6B756B'}
              onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            >
              About
            </button>
            <button 
              onClick={() => navigateToPage('/services')}
              className="text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              style={{ color: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.color = '#6B756B'}
              onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            >
              Services
            </button>
            <button 
              onClick={() => navigateToPage('/products')}
              className="text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              style={{ color: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.color = '#6B756B'}
              onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            >
              Products
            </button>
            <button 
              onClick={() => navigateToPage('/industries')}
              className="text-gray-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
              style={{ color: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.color = '#6B756B'}
              onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            >
              Industries
            </button>
            <button 
              onClick={() => navigateToPage('/quote')}
              className="text-white px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              style={{ backgroundColor: '#7E887E' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
            >
              Get Quote
            </button>
          </nav>

          <button 
            className="md:hidden text-gray-700 cursor-pointer"
            style={{ color: '#7E887E' }}
            onMouseEnter={(e) => e.target.style.color = '#6B756B'}
            onMouseLeave={(e) => e.target.style.color = '#7E887E'}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => navigateToPage('/')}
                className="text-gray-700 font-medium transition-colors cursor-pointer text-left whitespace-nowrap"
                style={{ color: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.color = '#6B756B'}
                onMouseLeave={(e) => e.target.style.color = '#7E887E'}
              >
                Home
              </button>
              <button 
                onClick={() => navigateToPage('/about')}
                className="text-gray-700 font-medium transition-colors cursor-pointer text-left whitespace-nowrap"
                style={{ color: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.color = '#6B756B'}
                onMouseLeave={(e) => e.target.style.color = '#7E887E'}
              >
                About
              </button>
              <button 
                onClick={() => navigateToPage('/services')}
                className="text-gray-700 font-medium transition-colors cursor-pointer text-left whitespace-nowrap"
                style={{ color: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.color = '#6B756B'}
                onMouseLeave={(e) => e.target.style.color = '#7E887E'}
              >
                Services
              </button>
              <button 
                onClick={() => navigateToPage('/products')}
                className="text-gray-700 font-medium transition-colors cursor-pointer text-left whitespace-nowrap"
                style={{ color: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.color = '#6B756B'}
                onMouseLeave={(e) => e.target.style.color = '#7E887E'}
              >
                Products
              </button>
              <button 
                onClick={() => navigateToPage('/industries')}
                className="text-gray-700 font-medium transition-colors cursor-pointer text-left whitespace-nowrap"
                style={{ color: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.color = '#6B756B'}
                onMouseLeave={(e) => e.target.style.color = '#7E887E'}
              >
                Industries
              </button>
              <button 
                onClick={() => navigateToPage('/quote')}
                className="text-white px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                style={{ backgroundColor: '#7E887E' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#6B756B'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#7E887E'}
              >
                Get Quote
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
